import { render, staticRenderFns } from "./clazz.vue?vue&type=template&id=a1e6f0f6&scoped=true&"
import script from "./clazz.vue?vue&type=script&lang=js&"
export * from "./clazz.vue?vue&type=script&lang=js&"
import style0 from "./clazz.vue?vue&type=style&index=0&id=a1e6f0f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e6f0f6",
  null
  
)

export default component.exports